import { render, staticRenderFns } from "./avar.vue?vue&type=template&id=f2949d5a&scoped=true&"
import script from "./avar.vue?vue&type=script&lang=js&"
export * from "./avar.vue?vue&type=script&lang=js&"
import style0 from "./avar.vue?vue&type=style&index=0&id=f2949d5a&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../viewport/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f2949d5a",
  null
  
)

export default component.exports